import DOMPurify from 'dompurify';

const AD_MODAL_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'a',
  'div',
  'span',
];

const AD_MODAL_ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeHomepageAdHtml(html: string): string {
  return DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: AD_MODAL_ALLOWED_TAGS,
    ALLOWED_ATTR: AD_MODAL_ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
